import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<rect width=\"20\" height=\"20\" rx=\"10\" fill=\"#B7B7B7\"></rect><g clip-path=\"url(#clip0_15469_4927)\"><path d=\"M11.5349 5.99995C11.5117 5.9758 11.4837 5.95667 11.4527 5.94377C11.4218 5.93087 11.3885 5.92447 11.3549 5.92495C11.2897 5.92456 11.2269 5.94968 11.1799 5.99495L5.71995 11.455C5.69651 11.4782 5.67792 11.5058 5.66522 11.5363C5.65253 11.5668 5.646 11.5995 5.646 11.6325C5.646 11.6655 5.65253 11.6981 5.66522 11.7286C5.67792 11.7591 5.69651 11.7867 5.71995 11.81L8.18995 14.28C8.23764 14.3278 8.30238 14.3548 8.36995 14.355C8.40264 14.3548 8.43497 14.348 8.46503 14.3351C8.49508 14.3223 8.52226 14.3035 8.54495 14.28L13.9999 8.82495C14.0461 8.77738 14.0719 8.71372 14.0719 8.64745C14.0719 8.58119 14.0461 8.51753 13.9999 8.46995L11.5349 5.99995Z\" fill=\"white\"></path><path d=\"M5.21491 12.4C5.18276 12.37 5.14341 12.3489 5.10067 12.3386C5.05794 12.3283 5.01328 12.3293 4.97102 12.3414C4.92876 12.3534 4.89034 12.3762 4.85948 12.4075C4.82863 12.4388 4.80638 12.4776 4.79491 12.52L4.03991 15.655C4.02991 15.6969 4.03111 15.7406 4.0434 15.7819C4.05569 15.8231 4.07863 15.8604 4.10991 15.89C4.14005 15.9205 4.17737 15.9428 4.21845 15.9551C4.25952 15.9673 4.30302 15.969 4.34491 15.96L7.49991 15.205C7.54291 15.1948 7.58234 15.1731 7.61403 15.1423C7.64572 15.1115 7.66848 15.0727 7.67991 15.03C7.69152 14.9874 7.69211 14.9426 7.68161 14.8997C7.67112 14.8569 7.64988 14.8174 7.61991 14.785L5.21491 12.4Z\" fill=\"white\"></path><path d=\"M15.6 5.46L14.54 4.4C14.3042 4.16732 13.9863 4.03687 13.655 4.03687C13.3238 4.03687 13.0058 4.16732 12.77 4.4L12.065 5.11C12.0411 5.13244 12.022 5.15955 12.009 5.18965C11.996 5.21975 11.9893 5.2522 11.9893 5.285C11.9893 5.31779 11.996 5.35024 12.009 5.38034C12.022 5.41044 12.0411 5.43755 12.065 5.46L14.54 7.96C14.5625 7.98391 14.5896 8.00297 14.6197 8.016C14.6498 8.02903 14.6822 8.03576 14.715 8.03576C14.7478 8.03576 14.7803 8.02903 14.8104 8.016C14.8405 8.00297 14.8676 7.98391 14.89 7.96L15.6 7.225C15.8336 6.99069 15.9648 6.67334 15.9648 6.3425C15.9648 6.01165 15.8336 5.6943 15.6 5.46Z\" fill=\"white\"></path></g><defs><clipPath id=\"clip0_15469_4927\"><rect width=\"12\" height=\"12\" fill=\"white\" transform=\"translate(4 4)\"></rect></clipPath></defs>", 3)
const _hoisted_5 = [
  _hoisted_2
]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'editIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#DBDBDB",
  },
  size: {
    type: Number as PropType<number>,
    default: 14,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
}

})